export const trainerWorkoutColumns = [
    {
        field: "branchName",
        headerName: "Branch Name",
        width: 130,
    },
    {
        field: "branchLocation",
        headerName: "Branch Loc",
        width: 130,
    },
    {
        field: "day",
        headerName: "Day",
        width: 160,
    },
    {
        field: "name",
        headerName: "Name",
        width: 160,
    },
    {
        field: "set1Exercise1",
        headerName: "Set1-Exercise1",
        width: 160
    },
    {
        field: "set1Reps1",
        headerName: "Set1-Reps1",
        width: 160,
    },
    {
        field: "set1Exercise2",
        headerName: "Set1-Exercise2",
        width: 160
    },
    {
        field: "set1Reps2",
        headerName: "Set1-Reps2",
        width: 160,
    },
    {
        field: "set1Exercise3",
        headerName: "Set1-Exercise3",
        width: 160
    },
    {
        field: "set1Reps3",
        headerName: "Set1-Reps3",
        width: 160,
    },
    {
        field: "set1Exercise4",
        headerName: "Set1-Exercise4",
        width: 160
    },
    {
        field: "set1Reps4",
        headerName: "Set1-Reps4",
        width: 160,
    },
    {
        field: "numberOfRounds1",
        headerName: "Number Of ROunds1",
        width: 160,
    },
    {
        field: "set2Exercise1",
        headerName: "Set2-Exercise1",
        width: 160
    },
    {
        field: "set2Reps1",
        headerName: "Set2-Reps1",
        width: 160,
    },
    {
        field: "set2Exercise2",
        headerName: "Set2-Exercise2",
        width: 160
    },
    {
        field: "set2Reps2",
        headerName: "Set2-Reps2",
        width: 160,
    },
    {
        field: "set2Exercise3",
        headerName: "Set2-Exercise3",
        width: 160
    },
    {
        field: "set2Reps3",
        headerName: "Set2-Reps3",
        width: 160,
    },
    {
        field: "set2Exercise4",
        headerName: "Set2-Exercise4",
        width: 160
    },
    {
        field: "set2Reps4",
        headerName: "Set2-Reps4",
        width: 160,
    },
    {
        field: "numberOfRounds1",
        headerName: "Number Of ROunds1",
        width: 160,
    },
];